function accessoryItemAddedCallback(div, product) { 


var shopMoneyFormat = window.PXUTheme.currency.money_format;
var originalCurrency = '';
var newCurrency = getCookie('cart_currency');

//price
var item = $(div).get(0);
var originalPrice = item.querySelector(".accessory-price:not(.small)").innerText;
originalPrice = Number(originalPrice.replace(/[^0-9\.]+/g, "") * 100);    
var formattedAdditional = Shopify.formatMoney(originalPrice, shopMoneyFormat);
  
item.querySelector(".accessory-price:not(.small)").innerText = formattedAdditional;

//compare at price
var discountPrice = item.querySelector(".accessory-price.small").innerText;
discountPrice = Number(discountPrice.replace(/[^0-9\.]+/g, "") * 100);
var formattedDiscount = Shopify.formatMoney(discountPrice, shopMoneyFormat);

if(discountPrice != 0){
item.querySelector(".accessory-price.small").innerText = formattedDiscount;
}

function getCookie(name) {
var value = "; " + document.cookie;
var parts = value.split("; " + name + "=");
if (parts.length == 2) return parts.pop().split(";").shift();
}

}